import { Controller } from "@hotwired/stimulus";

/**
 * « Pour qui » of a « Générer » page (29/10/2026): shows the picker of the
 * chosen scope (the pupil, the classes…) and hides the others. The live
 * check is reloaded by form-refresh, on the enclosing form.
 *
 * A choice elsewhere in the form wrapped in data-audience-scopes (the
 * individual disciplinary sheet: « Un élève » only) follows the scope too.
 *
 * <div data-controller="generation-audience">
 *   <input type="radio" value="one_class" data-action="change->generation-audience#show">
 *   <div data-generation-audience-target="panel" data-scope="one_class" hidden>…</div>
 */
export default class extends Controller {
  static targets = ["panel"];

  show(event) {
    const scope = event.target.value;
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.scope !== scope;
    });
    this.toggleScopedChoices(scope);
  }

  // A choice elsewhere in the form that only some audiences allow
  // (data-audience-scopes="one_student"): hidden and disabled otherwise; if
  // it was ticked, the first choice left of its group is ticked instead.
  toggleScopedChoices(scope) {
    const form = this.element.closest("form");
    if (!form) return;
    form.querySelectorAll("[data-audience-scopes]").forEach((wrapper) => {
      const allowed = wrapper.dataset.audienceScopes.split(" ").includes(scope);
      wrapper.hidden = !allowed;
      wrapper.querySelectorAll("input").forEach((input) => {
        const wasChecked = input.checked;
        input.disabled = !allowed;
        if (allowed || !wasChecked) return;
        input.checked = false;
        const fallback = Array.from(form.querySelectorAll(`input[name="${input.name}"]`))
          .find((other) => !other.disabled);
        if (fallback) fallback.checked = true;
      });
    });
  }
}
